import { CASES } from "./constants";
import { safeGetJSON } from "tap/utils/safeLocalStorage";
import {
  DEFAULT_PAGE_SIZE_OPTIONS,
  getInitialPaginationRange,
  getStoredItemsPerPage,
  PAGINATION_STORAGE_KEYS,
  persistItemsPerPageFromPayload,
  withPreservedPagination,
} from "tap/utils/paginationPreferences.js";

const paginationKeys = {
  itemsPerPage: PAGINATION_STORAGE_KEYS.pmxPricesAndDates,
};
const initialItemsPerPage = getStoredItemsPerPage(paginationKeys.itemsPerPage);
const initialPaginationRange = getInitialPaginationRange(initialItemsPerPage);

const getInitialPMXPricesAndDatesSort = () => {
  return safeGetJSON("pmxPricesAndDatesSort", ["id", "DESC"]);
};

const initialState = {
  pricesAndDates: [],
  refreshPMXPricesAndDates: false,
  filterForm: {
    isHistoricalRecord: "",
    catalogId: "",
    catalogName: "",
    productType: "",
    territory: "",
    productPlatform: "",
    productConfig: "",
    pmxReleaseId: "",
  },
  rlHistoricalRecordOptions: [
    { value: true, label: "Yes" },
    { value: false, label: "No" },
  ],
  productTypeOptions: [
    { value: "Digital", label: "Digital" },
    { value: "Physical", label: "Physical" },
  ],
  productConfigOptions: [
    { value: "EHV-HD", label: "EHV-HD" },
    { value: "EHV-SD", label: "EHV-SD" },
    { value: "EHV-UHD", label: "EHV-UHD" },
    { value: "EHV-3D", label: "EHV-3D" },
    { value: "PEHV - HD", label: "PEHV - HD" },
    { value: "PEHV - SD", label: "PEHV - SD" },
    { value: "PEHV - UHD", label: "PEHV - UHD" },
    { value: "PEHV - 3D", label: "PEHV - 3D" },
    { value: "PVOD - HD", label: "PVOD - HD" },
    { value: "PVOD - SD", label: "PVOD - SD" },
    { value: "PVOD - UHD", label: "PVOD - UHD" },
    { value: "PVOD - 3D", label: "PVOD - 3D" },
    { value: "VOD - HD", label: "VOD - HD" },
    { value: "VOD - SD", label: "VOD - SD" },
    { value: "VOD - UHD", label: "VOD - UHD" },
    { value: "VOD - 3D", label: "VOD - 3D" },
  ],
  territoryOptions: [],
  productPlatformOptions: [],
  totalPages: 0,
  totalItems: 0,
  currentPage: 0,
  filterParam: "",
  pmxPricesAndDatesRange: initialPaginationRange,
  pmxPricesAndDatesSort: getInitialPMXPricesAndDatesSort(),
  defaultFilterRange: initialPaginationRange,
  itemsPerPage: initialItemsPerPage,
  pageSizeOptions: DEFAULT_PAGE_SIZE_OPTIONS,
};

export function pmxPricesAndDates(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case CASES.UPDATE_PMX_PRICES_AND_DATES: {
      if (payload.pmxPricesAndDatesSort) {
        localStorage.setItem(
          "pmxPricesAndDatesSort",
          JSON.stringify(payload.pmxPricesAndDatesSort),
        );
      }
      persistItemsPerPageFromPayload(payload, paginationKeys);
      return { ...state, ...payload };
    }
    case CASES.UPDATE_PMX_PRICES_AND_DATES_SEARCH_FORM: {
      const { data, key } = payload;
      return { ...state, [key]: { ...state[key], ...data } };
    }
    case CASES.CLEAR_PMX_PRICES_AND_DATES: {
      return withPreservedPagination(
        state,
        {
          ...initialState,
          pmxPricesAndDatesSort: state.pmxPricesAndDatesSort,
          territoryOptions: state.territoryOptions,
          productPlatformOptions: state.productPlatformOptions,
        },
        ["pmxPricesAndDatesRange"],
      );
    }
    default:
      return state;
  }
}
